
import { defineComponent } from "vue";
import DownloadButtons from "@/components/DownloadButtons.vue";

export default defineComponent({
  name: "Download",
  components: {
    DownloadButtons,
  },
});
